import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Modal } from "antd";
import { FILE_URL } from "../constants/Constants";

const FreebookCard = ({ logo, title, subtitle, link, type }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => setIsModalVisible(true);
  const handleCancel = () => setIsModalVisible(false);

  return (
    <>
      <Link
        onClick={() => type === "videos" && setIsModalVisible(true)}
        to={type === "videos" ? "" : link}
        target={type === "videos" ? "" : "_blank"}
      >
        <div
          className={`${
            type === "videos" ? "rounded-xl p-0" : "rounded-3xl p-4 border"
          }  bg-white relative w-full overflow-hidden`}
        >
          <div
            className={
              type === "videos"
                ? "rounded-xl w-full h-48 cursor-pointer"
                : type === "newspaper"
                ? "newspaper-image w-[209px] h-[117px] rounded-none cursor-pointer object-cover overflow-hidden"
                : "rounded-3xl h-48 w-full cursor-pointer"
            }
            onClick={type === "videos" ? showModal : null}
          >
            {type === "videos" ? (
              <video
                width="100%"
                height="100%"
                className="h-full w-full"
                controls
                // autoplay
                controlsList="nodownload"
                oncontextmenu="return false;"
              >
                <source src={FILE_URL + logo} type="video/mp4" />
              </video>
            ) : (
              // <iframe
              //   src={FILE_URL + logo}
              //   className="h-full w-full object-cover rounded-xl"
              //   title={title}
              //   frameBorder="0"
              //   allowFullScreen
              // />
              <img
                className={`${
                  type === "newspaper" ? "rounded-none" : "rounded-3xl"
                } h-full w-full  object-cover `}
                alt="image"
                src={FILE_URL + logo}
              />
            )}
          </div>

          <Link
            onClick={() => type === "videos" && setIsModalVisible(true)}
            to={type === "videos" ? "" : link}
            target={type === "videos" ? "" : "_blank"}
            className="w-full mt-4 text-center"
          >
            <h2
              className={`${
                type === "videos" ? "text-start px-2" : "text-center"
              } text-base  font-bold truncate overflow-hidden mt-2`}
            >
              {title}
            </h2>
            {type !== "newspaper" && (
              <p
                className={` ${
                  type === "videos" ? "text-start px-2" : "text-center"
                } text-sm mx-auto w-full  font-medium text-[#545454]`}
              >
                {subtitle}
              </p>
            )}
          </Link>
        </div>
      </Link>
      {type === "videos" && (
        <Modal
          open={isModalVisible}
          onOk={() => setIsModalVisible(false)}
          onCancel={() => setIsModalVisible(false)}
          destroyOnClose
          centered
          footer={null}
          closeIcon={false}
          // visible={isModalVisible}
          // onCancel={handleCancel}
          // footer={null}
          width="80%"
          // centered
        >
          <video
            width="100%"
            height="100%"
            className="h-96 w-full"
            controls
            // autoplay
            controlsList="nodownload"
            oncontextmenu="return false;"
          >
            <source src={FILE_URL + logo} type="video/mp4" />
          </video>

          {/* <iframe
            src={FILE_URL + logo}
            className="w-full h-96 rounded-2xl"
            title={title}
            frameBorder="0"
            allowFullScreen
            
          /> */}
        </Modal>
      )}
    </>
  );
};

export default FreebookCard;
